import React from 'react';

const OverviewCard = ({ project, metadata, transcript, currentSynopsis }) => {
  // Format date helper
  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    } catch {
      return dateStr;
    }
  };
  
  const videoDuration = metadata?.duration_seconds 
    ? `${Math.floor(metadata.duration_seconds)}s` 
    : 'N/A';
  
  const projectId = project?.id?.substring(0, 14) || 'N/A';
  
  const creatorDisplay = project?.created_by_name
    ? (project?.created_via === 'client' ? `${project.created_by_name} (Client)` : project.created_by_name)
    : 'N/A';
  const infoItems = [
    { label: 'PROJECT CREATOR', value: creatorDisplay },
    { label: 'PROJECT ID', value: projectId },
    { label: 'PROJECT NAME', value: project?.title || project?.name || 'N/A' },
    { label: 'CREATED DATE', value: formatDate(project?.createdAt) },
    { label: 'UPDATED DATE', value: formatDate(project?.updatedAt) },
    { label: 'VIDEO DURATION', value: videoDuration },
  ];
  
  return (
    <div>
      <div className="p-2 border-b border-border">
        <h3 className="text-xs font-semibold text-foreground">Overview</h3>
      </div>
      <div className="p-2 space-y-2">
        {infoItems.map((item, index) => (
          <div key={index} className="grid grid-cols-2 gap-4 text-[10px]">
            <div className="text-foreground font-medium uppercase">{item.label}</div>
            <div className="text-foreground truncate">{item.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OverviewCard;

